<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <label><strong>{{ perfil.perfil }}</strong></label>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label>{{ perfil.descricao || "-" }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <hr>
  </div>
</template>

<script>

export default {
  name: "PerfilAplicacaoComponent",

  props: {
    perfil: {
      type: Object,
      required: false
    }
  },
}
</script>